import gaEventTracker, { events } from "util/gaEventTracker";

export const types = {
    GET_REFILLS_FORM_REQUEST: "refills/GET_REFILLS_FORM_REQUEST",
    GET_REFILLS_FORM_FAILURE: "refills/GET_REFILLS_FORM_FAILURE",
    GET_REFILLS_FORM_SUCCESS: "refills/GET_REFILLS_FORM_SUCCESS",
    SET_DATA_REFILLS_FORM: "refills/SET_DATA_REFILLS_FORM",
    PREPARE_REFILLS_FORM_REQUEST: "refills/PREPARE_REFILLS_FORM_REQUEST",
    PREPARE_REFILLS_FORM_FAILURE: "refills/PREPARE_REFILLS_FORM_FAILURE",
    PREPARE_REFILLS_FORM_SUCCESS: "refills/PREPARE_REFILLS_FORM_SUCCESS",
    CLEAN_REFILLS_TICKET: "refills/CLEAN_REFILLS_TICKET",
    PAY_SERVICE_REQUEST: "refills/PAY_SERVICE_REQUEST",
    PAY_SERVICE_SUCCESS: "refills/PAY_SERVICE_SUCCESS",
    PAY_SERVICE_FAILURE: "refills/PAY_SERVICE_FAILURE",
};

export const INITIAL_STATE = {
    fetching: false,
    formRequest: null,
    formData: {},
    message: "",
    refillsTicket: { status: "", idTransaction: "" },
};

export default (state = INITIAL_STATE, action = {}) => {
    const { formRequest, formData, refillsTicket, message } = action;

    switch (action.type) {
        case types.GET_REFILLS_FORM_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.GET_REFILLS_FORM_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.GET_REFILLS_FORM_SUCCESS:
            return {
                ...state,
                fetching: false,
                formRequest,
            };
        case types.SET_DATA_REFILLS_FORM:
            return {
                ...state,
                formData,
            };
        case types.PREPARE_REFILLS_FORM_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.PREPARE_REFILLS_FORM_FAILURE:
            return {
                ...state,
                fetching: false,
                refillsTicket,
            };
        case types.PREPARE_REFILLS_FORM_SUCCESS:
            return {
                ...state,
                fetching: false,
                refillsTicket,
            };
        case types.CLEAN_REFILLS_TICKET:
            return {
                ...state,
                refillsTicket: { status: "", idTransaction: "" },
            };
        case types.PAY_SERVICE_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.PAY_SERVICE_SUCCESS:
            return {
                ...INITIAL_STATE,
                refillsTicket,
                fetching: false,
            };
        case types.PAY_SERVICE_FAILURE:
            return {
                ...state,
                message,
                fetching: false,
            };
        default:
            return state;
    }
};

export const actions = {
    refillsGetForm: () => ({
        type: types.GET_REFILLS_FORM_REQUEST,
    }),
    refillsFormData: (formData) => ({
        type: types.SET_DATA_REFILLS_FORM,
        formData,
    }),
    refillsPreparePay: (requestData) => ({
        type: types.PREPARE_REFILLS_FORM_REQUEST,
        request_data: requestData,
    }),
    cleanRefillsTicket: () => ({
        type: types.CLEAN_REFILLS_TICKET,
    }),
    payService: (paymentData, credentialType, formikBag) => {
        gaEventTracker.triggerEvent(events.pagos_recargas());
        return {
            type: types.PAY_SERVICE_REQUEST,
            paymentData: { ...paymentData, enrollService: false },
            credentialType,
            formikBag,
        };
    },
};

export const selectors = {
    refillsGetForm: ({ refills }) => refills.formRequest,
};
